import classNames from 'classnames';
import { useOutlet } from 'react-router-dom';
import { OutletSheet } from './ui/nucleus/Sheets/OutletSheet';
import { AccountSettings } from './users/settings/account';
import { UserSettings } from './users/settings/user';

type Props = {
  children: React.ReactNode;
  rsbSmall?: boolean;
};

export function Layout({ children, rsbSmall }: Props) {
  const outlet = useOutlet();
  return (
    <>
      {/* Settings overlays are mounted globally so hash toggles work everywhere */}
      <UserSettings />
      <AccountSettings />
      <div className='flex h-full items-stretch lg:h-screen-minus-nav'>
        <div className='min-h-0 flex-1 overflow-y-auto overflow-x-hidden border-r'>
          {children}
        </div>
        {outlet && (
          <div
            data-outlet
            className={classNames(
              'min-w-rsb absolute inset-0 overflow-y-auto overflow-x-hidden lg:static',
              rsbSmall ? 'lg:w-rsb' : 'lg:w-rsb xl:w-2rsb'
            )}
          >
            <OutletSheet isOpen={true} onClose={() => {}}>
              {outlet}
            </OutletSheet>
          </div>
        )}
      </div>
    </>
  );
}
